module.exports = __webpack_public_path__ + "media/logos/Samsung 1-fb5381c2.svg";